<template>
  <div class="demand-requirement">
    <div class="df both-side">
      <a-space>
        <div>{{ route.query.projectName }}</div>
        <a-input
          v-model:value="requestPayload.WBS"
          placeholder="WBS"
          @change="handleSearch"
          allowClear
          style="width: 160px"
        >
        </a-input>
        <!-- <a-select
          v-model:value="requestPayload.structureName"
          placeholder="组织架构名称"
          @change="handleSearch"
          :options="structureOptions"
          style="width: 160px"
          allowClear
        ></a-select> -->
        <a-select
          v-model:value="requestPayload.softwareOrHardware"
          placeholder="请选择类型"
          @change="handleSearch"
          allowClear
          style="width: 120px"
        >
          <a-select-option value="software">软件</a-select-option>
          <a-select-option value="hardware">硬件</a-select-option>
        </a-select>

        <!-- <a-select
          v-model:value="requestPayload.username"
          placeholder="类型"
          @change="handleSearch"
          allowClear
        >
          <a-select-option :value="null">全部</a-select-option>
          <a-select-option :value="user.nickName">需处理</a-select-option>
        </a-select> -->

        <!-- <a-input
          v-model:value="requestPayload.username"
          placeholder="提出人"
          allowClear
          @change="handleSearch"
        >
        </a-input>

        <a-input
          v-model:value="requestPayload.executor"
          placeholder="执行人"
          allowClear
          @change="handleSearch"
        >
        </a-input> -->

        <a-select
          v-model:value="requestPayload.username"
          show-search
          placeholder="发布人"
          style="width: 200px"
          :options="staffList"
          @change="handleSearch"
          allowClear
        >
        </a-select>

        <a-select
          v-model:value="requestPayload.executor"
          show-search
          placeholder="执行人"
          style="width: 200px"
          :options="staffList"
          @change="handleSearch"
          allowClear
        >
        </a-select>
      </a-space>

      <a-space>
        <a-button @click="handleInsertDemand" type="primary">新增</a-button>
      </a-space>
    </div>
    <!-- 
    <demand-table
      :tableData="table"
      @handleUpdateRecord="handleUpdateRecord"
      @updateTable="getListData"
    ></demand-table> -->
    <a-table
      bordered
      :data-source="table.data"
      :pagination="false"
      :columns="columns"
      :rowClassName="
        (record, index) =>
          index % 2 === 1 ? 'special-row table-striped' : 'special-row'
      "
      :scroll="{ x: 'calc(100vw - 80px)', y: 'calc(100vh - 230px)' }"
      rowKey="id"
      class="table-space"
    >
      <template #softwareOrHardware="{ record }">
        <div v-if="record.softwareOrHardware">
          {{ record.softwareOrHardware === "hardware" ? "硬件" : "软件" }}
        </div>
      </template>

      <template #startDate="{ record }">
        <div class="output-result">{{ record.releaseStartTime }}</div>
        <div class="output-result">{{ record.scheduledStartTime }}</div>
        <div class="output-result">{{ record.actualReleaseStartTime }}</div>
      </template>

      <template #endDate="{ record }">
        <div class="output-result">{{ record.releaseEndTime }}</div>
        <div class="output-result">{{ record.scheduledEndTime }}</div>
        <div class="output-result">{{ record.actualReleaseEndTime }}</div>
      </template>

      <template #scheduleStatus="{ record }">
        <a-tag v-if="record.scheduleStatus === '发布'" color="#108ee9">{{
          record.scheduleStatus
        }}</a-tag>
        <a-tag
          v-if="record.scheduleStatus === '移至项目计划'"
          color="#87d068"
          >{{ record.scheduleStatus }}</a-tag
        >
        <a-tag v-if="record.scheduleStatus === '停止'">{{
          record.scheduleStatus
        }}</a-tag>
      </template>

      <template #execute="{ record }">
        <div class="output-result">
          <a-button
            size="small"
            type="primary"
            @click="handleUpdateRecord(record, 'release')"
            :disabled="!isProjectLeader"
            >发布</a-button
          >
        </div>
        <div class="output-result">
          <a-button
            size="small"
            type="primary"
            @click="handleUpdateRecord(record, 'scheduled')"
            :disabled="user.id !== record.plannerId"
            >计划</a-button
          >
        </div>
        <div class="output-result">
          <a-button
            size="small"
            type="primary"
            @click="handleUpdateRecord(record, 'actualRelease')"
            :disabled="user.id !== record.executorId"
          >
            实际
          </a-button>
        </div>
      </template>

      <template #completionDegree="{ record }">
        <div v-if="record.completionDegree">
          {{ record.completionDegree }} %
        </div>
      </template>
      <template #fileLink="{ record }">
        <!-- <a-button
          type="primary"
          size="small"
          @click="handleDownloadFile(record.fileLink)"
          v-if="record.fileLink"
          >下载</a-button
        > -->
        <file :file="record.fileLink"></file>
      </template>

      <template #workRecords="{ record }">
        <div class="task-result">
          <template
            v-if="record.workRecords && record.workRecords.indexOf('[') !== -1"
          >
            <div
              v-for="(item, index) in JSON.parse(record.workRecords).reverse()"
              :key="index"
              class="outupt-result-text-left"
            >
              {{ JSON.parse(record.workRecords).length - index }}
              {{}}、{{
                  item.value
              }}
            </div>
          </template>
        </div>
      </template>

      <template #action="{ record }">
        <a-space>
          <a-button
            size="small"
            type="primary"
            @click="handleUpdateRecord(record, 'edit')"
            :disabled="isProjectLeader ? false : user.id !== record.userId"
            >编辑</a-button
          >
          <a-button
            size="small"
            type="danger"
            @click="handleDeleteRecord(record)"
            :disabled="isProjectLeader ? false : user.id !== record.userId"
            >删除</a-button
          >
        </a-space>
      </template>
    </a-table>

    <div class="df both-side" style="margin-top: 10px">
      <div></div>
      <a-pagination
        v-model:current="table.pageNum"
        :total="table.total"
        :show-total="(total) => `共 ${table.total} 条`"
        @change="hanldeUpdatePageNum"
        show-size-changer
        show-quick-jumper
      />
    </div>
  </div>
  <demand-form ref="demandFormRef" @updateTable="getListData"></demand-form>
</template>

<script>
import {
  computed,
  defineComponent,
  inject,
  onBeforeMount,
  reactive,
  ref,
  watch,
} from "vue";
import store from "@/store";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { debounce } from "@/utils";
import { useTable } from "@/views/notice/serve/table";
import { structureOptions } from "@/views/rdmanagement/components/database/options";
import {
  getProblemRequirementScheduleList,
  deleteProblemRequirementSchedule,
} from "@/request/view/project";
import { download } from "@/views/rdmanagement/serve/index";
import {
  getStaffListData,
  staffList,
} from "@/views/rdmanagement/components/projectScheme/staffUser";
import demandForm from "@/views/rdmanagement/components/demand/form.vue";
import demandTable from "@/views/rdmanagement/components/demand/table.vue";
import file from '@/views/rdmanagement/components/file/index.vue';


export default defineComponent({
  components: { demandForm, demandTable, file },
  props: {
    type: String,
  },
  setup(props) {
    const route = useRoute();
    const user = useStore().state.user.user;
    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
      hanldeUpdatePageNum,
    } = useTable();

    const isProjectLeader = ref(false);

    const activeKey = inject("activeKey", null);

    requestConfig.pull_fn = getProblemRequirementScheduleList;
    requestConfig.delete_fn = deleteProblemRequirementSchedule;

    const columns = reactive([
      {
        title: "wbs",
        dataIndex: "wbs",
        align: "center",
        width: "140px",
        fixed: "left",
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        align: "center",
        width: "140px",
        fixed: "left",
      },
      {
        title: "类型",
        slots: {
          customRender: "softwareOrHardware",
        },
        align: "center",
        width: "100px",
      },
      {
        title: `${props.type}描述`,
        dataIndex: "description",
        align: "center",
      },
      {
        title: "提出人",
        dataIndex: "username",
        align: "center",
        width: "100px",
      },
      {
        title: "状态",
        dataIndex: "scheduleStatus",
        align: "center",
        width: "140px",
        slots: {
          customRender: "scheduleStatus",
        },
      },
      {
        title: "计划人",
        dataIndex: "planner",
        align: "center",
        width: "100px",
      },
      {
        title: "执行人",
        dataIndex: "executor",
        align: "center",
        width: "100px",
      },
      {
        title: "执行",
        align: "center",
        slots: {
          customRender: "execute",
        },
        width: "80px",
      },
      {
        title: "开始日期",
        align: "center",
        slots: {
          customRender: "startDate",
        },
        width: "120px",
      },
      {
        title: "结束日期",
        align: "center",
        slots: {
          customRender: "endDate",
        },
        width: "120px",
      },
      {
        title: "完成率",
        align: "center",
        slots: {
          customRender: "completionDegree",
        },
        width: "100px",
      },
      {
        title: "文件",
        align: "center",
        slots: {
          customRender: "fileLink",
        },
        width: "100px",
      },
      {
        title: "工作记录",
        align: "center",
        slots: {
          customRender: "workRecords",
        },
      },
      {
        title: "备注",
        dataIndex: "assistanceNeeded",
        align: "center",
      },
      {
        title: "操作",
        align: "center",
        slots: {
          customRender: "action",
        },
        width: "140px",
      },
    ]);

    const demandFormRef = ref();

    const handleInsertDemand = () => {
      demandFormRef.value.showModal({
        type: props.type,
        isInsert: true,
        title: `新增${props.type}`,
      });
    };

    const handleUpdateRecord = (data, type) => {
      demandFormRef.value.showModal({
        type: props.type,
        isInsert: false,
        title: `修改${props.type}`,
        data,
        step: type,
      });
    };

    const handleSearch = debounce(() => {
      console.log(route.query, "");
      requestPayload.pageNum = 1;
      getListData();
    }, 200);

    const handleDeleteRecord = (record) => {
      deleteRecords([record.id], {
        title: "确定删除记录？",
      }).then(() => {
        getListData();
      });
    };

    const setSearchPayload = () => {
      const structureName =
        user.secondaryDepartment || user.firstLevelDepartment;
      const ware =
        structureName.indexOf("软件") !== -1 ? "software" : "hardware";
      initPayload({
        WBS: null,
        projectLifeCycle: route.query.projectLifeCycle,
        projectLifeCycleId: route.query.projectId,
        // softwareOrHardware: ware,
        // structureName: structureName,
        type: props.type,
        username: null,
        executor: null,
      });
    };

    const setNoticePayload = () => {
      const structureName =
        user.secondaryDepartment || user.firstLevelDepartment;
      const ware =
        structureName.indexOf("软件") !== -1 ? "software" : "hardware";
      initPayload({
        WBS: route.query.wbs,
        projectLifeCycle: route.query.projectLifeCycle,
        projectLifeCycleId: route.query.projectId,
        softwareOrHardware: null,
        structureName: null,
        executor: null,
        type: props.type,
        username: null,
      });
    };

    const strategy = {
      normalEnter: setSearchPayload,
      webSocketNoticeEnter: setNoticePayload,
    };

    const handleDownloadFile = (url) => {
      download(url, "下载");
    };

    // onBeforeMount(() => {
    //   if (
    //     route.query.type === "link" &&
    //     activeKey.value === route.query.activeKey
    //   ) {
    //     strategy.webSocketNoticeEnter();
    //   } else {
    //     strategy.normalEnter();
    //   }
    //   getListData();
    // });

    watch(
      () => route,
      (val) => {
        if (route.path === "/rdprojectlayout") {
          requestPayload.WBS = route.query.wbs;
          requestPayload.projectLifeCycle = route.query.projectLifeCycle;
          requestPayload.projectLifeCycleId = route.query.projectId;
          requestPayload.type = props.type;
          if (
            route.query.type === "link" &&
            activeKey.value === route.query.activeKey
          ) {
            strategy.webSocketNoticeEnter();
          } else {
            strategy.normalEnter();
          }
          getListData();

          isProjectLeader.value =
            store.state.user.user.nickName === route.query.projectLeader;
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => activeKey,
      (val) => {
        if (val.value.indexOf(props.type) !== -1) {
          getListData();
        }
      },
      {
        deep: true,
      }
    );

    if (staffList.value.length === 0) {
      getStaffListData();
    }

    return {
      table,
      user,
      columns,
      staffList,
      route,
      demandFormRef,
      requestPayload,
      handleDownloadFile,
      structureOptions,
      handleSearch,
      getListData,
      hanldeUpdatePageNum,
      isProjectLeader,
      handleUpdateRecord,
      handleInsertDemand,
      handleDeleteRecord,
    };
  },
});
</script>

<style lang="less" scoped>
.table-space {
  margin: 10px 0;
}

.task-result {
  height: 92px;
  overflow-y: auto;
}
.outupt-result-text-left {
  text-align: left;
}
</style>
